import React from 'react';
import PropTypes from 'prop-types';
require('es6-promise').polyfill();
import Axios from 'axios';
import { DoorDialog } from './styled/AdventCalendar';
import UserData from './steps/UserData';
import Prize from './steps/Prize';
import Question from './steps/Question';
import QuestionContent from './steps/QuestionContent';
import Answer from './steps/Answer';
import Finish from './steps/Finish';
import Step from './elements/Step';
import { formSchemaPropType } from '../../formSchema';

export default class DoorDialogContainer extends React.Component {
  constructor(props) {
    super(props);

    this.proceedToNextStep = this.proceedToNextStep.bind(this);
    this.handleDoorClose = this.handleDoorClose.bind(this);
    this.collectUserData = this.collectUserData.bind(this);
    this.collectAnswer = this.collectAnswer.bind(this);
    this.handleSuccessSubmit = this.handleSuccessSubmit.bind(this);
    this.handleExistingEntrySubmit = this.handleExistingEntrySubmit.bind(this);

    this.state = this.getInitialState();
  }

  getInitialState = () => {
    const {
      collectUserData,
      hasQuiz,
      showAnswer,
      data,
      formSchema,
    } = this.props;

    const {
      calendardoor_question,
      calendardoor_no_winner,
    } = data;

    let prizeToStep = 'question';
    let questionToStep = 'user-data';
    let answerToStep = 'user-data';

    if (!collectUserData) {
      if ( !showAnswer ) {
        questionToStep = 'finish';
      } else {
        questionToStep = 'answer';
      }
    } else {
      if ( showAnswer ) {
        questionToStep = 'answer';
      }
    }

    if (!hasQuiz) {
      prizeToStep = 'user-data';
      questionToStep = 'user-data';
      if (!collectUserData) {
        prizeToStep = 'finish';
        questionToStep = 'finish';
      }
    }

    const defaultFormData = {};
    Object.keys(formSchema).forEach((field) => {
      if (formSchema[field].repeat) {
        defaultFormData[formSchema[field].name] = formSchema[field].repeat[0].value;
      } else {
        defaultFormData[formSchema[field].name] = '';
      }
    });

    const fieldValidations = {};
    Object.keys(formSchema).forEach((field) => {
      fieldValidations[formSchema[field].name] = {
        valid: true,
        message: '',
      };
    });

    return {
      dialogDisplayed: (calendardoor_question === 'on' || calendardoor_no_winner === 'on') ? 'question' : 'prize',
      steps: {
        prize: {
          name: 'prize',
          toStep: prizeToStep,
        },
        question: {
          name: 'question',
          toStep: questionToStep,
        },
        answer: {
          name: 'answer',
          toStep: answerToStep,
        },
        userData: {
          name: 'user-data',
          toStep: 'finish',
        },
        finish: {
          name: 'finish',
        },
        entryExists: {
          name: 'entry-exists',
        },
      },
      userData: {
        door_id: data.ID,
        answer: [],
        givenAnswer: false,
        ...defaultFormData,
      },
      fieldValidations,
      entryExists: false,
    };
  };

  validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  isNum = (num) => (/^-?\d+$/.test(num) || /^-?\d+\.\d+$/.test(num));

  validateFields = () => {
    const {
      formSchema,
      emptyFieldMsg,
      emailFieldMsg,
    } = this.props;
    const { fieldValidations, userData } = this.state;
    const {
      AdventCount: {
        translations: {
          common: {
            numbersOnly,
          },
        },
      },
    } = window;

    const validations = fieldValidations;
    let formValid = true;

    Object.keys(formSchema).forEach((field) => {
      if (formSchema[field].req && userData[formSchema[field].name].trim() === '') {
        validations[formSchema[field].name] = {
          valid: false,
          message: emptyFieldMsg,
        };
        formValid = false;
      } else {
        if (formSchema[field].field_type === 'email' && userData[formSchema[field].name].trim() !== '' && !this.validateEmail(userData[formSchema[field].name])) {
          validations[formSchema[field].name] = {
            valid: false,
            message: emailFieldMsg,
          };
          formValid = false;
        }
        if (formSchema[field].field_type === 'number' && userData[formSchema[field].name].trim() !== '' && !this.isNum(userData[formSchema[field].name])) {
          validations[formSchema[field].name] = {
            valid: false,
            message: numbersOnly,
          };
          formValid = false;
        }
      }
    });

    if (formValid) {
      return true;
    }

    this.setState({
      fieldValidations: validations,
    });

    return false;
  };

  collectUserData = (key, value) => {
    const { userData, fieldValidations } = this.state;
    const fieldValidationsState = fieldValidations;
    const userDataState = userData;

    userDataState[key] = value;
    fieldValidationsState[key] = {
      valid: true,
      message: '',
    };

    this.setState({
      userData: userDataState,
      fieldValidations: fieldValidationsState,
    });
  };

  collectAnswer = (values) => {
    const trimmedValue = values.map((value) => (value.trim()));
    this.setState((prevState) => (
      {
        userData: {
          ...prevState.userData,
          answer: trimmedValue,
        },
      }
    ));
  };

  backToPreviousStep = (event) => {
    // only used for wrong answers now, not for usage throughout the steps
    this.setState({
      dialogDisplayed: 'question',
    });
  }

  proceedToNextStep = (event) => {
    const {
      steps,
      dialogDisplayed,
      userData,
      fieldValidations,
    } = this.state;
    const { entryUrl, showAnswer, data } = this.props;
    const toStep = event.currentTarget.getAttribute('data-to-step');

    if (dialogDisplayed === steps.userData.name) {
      if (this.validateFields()) {
        Axios.post(entryUrl, userData)
          .then((response) => {
            const { data: { form_errors, entryExists } } = response;

            if (!form_errors && !entryExists) {
              this.handleSuccessSubmit();
            }
          })
          .catch((reason) => {
            const {
              response: { data },
            } = reason;
            const { form_errors, entryExists } = data;

            if (form_errors) {
              this.setState({
                fieldValidations: {
                  ...fieldValidations,
                  ...form_errors,
                },
              });
            }
            if (entryExists) {
              this.handleExistingEntrySubmit();
              this.setState({
                dialogDisplayed: steps.entryExists.name,
              });
            }
          });
      }
    } else {

      if ( dialogDisplayed === steps.question.name ) {
        if ( showAnswer ) {
          var givenAnswer = false;
          switch ( data.calendardoor_answer_type ) {
            case 'Yes / No':
              if ( parseInt( data.correct_answer[0] ) == parseInt( userData.answer[0] ) ) {
                givenAnswer = true;
              }
              break;
            case 'Multiple Choice':
              // need to rewrite the userData.answer as it only gives the index of the array instead of a full array with true and false
              // how many answer possibilites do we have in total? count the array
              const correctAnswersLength = data.correct_answer.length;

              // create a new array with that many items
              let givenMCAnswer = new Array(correctAnswersLength);

              // add zeros so we can compare properly
              givenMCAnswer.fill("0");

              // now we iterate over the array of given answers to fill the newly created array
              for ( const item of userData.answer ) {
                givenMCAnswer[item] = "1";
              }

              // this complicated if was sneaked from the internet but this is what we need
              // it basically checks if both arrays are:
              // - arrays
              // - that they have the same length
              // - that their contents match exactly
              if ( Array.isArray(data.correct_answer) && Array.isArray(givenMCAnswer) &&
                    data.correct_answer.length === givenMCAnswer.length &&
                    data.correct_answer.every((val, index) => val === givenMCAnswer[index]) ) {
                givenAnswer = true;
              }

              break;
            case 'Number':
              if ( parseInt( data.correct_answer[0] ) == parseInt( userData.answer[0] ) ) {
                givenAnswer = true;
              }
              break;
            case 'Text':
              if ( data.correct_answer[0] == userData.answer[0] ) {
                givenAnswer = true;
              }
              break;
          }
          this.setState((prevState) => (
            {
              userData: {
                ...prevState.userData,
                givenAnswer: givenAnswer,
              },
            }
          ));
        }
      }

      this.setState({
        dialogDisplayed: toStep,
      });
    }
  };

  handleSuccessSubmit = () => {
    const {
      steps,
    } = this.state;
    const {
      successDisplayed,
      successType,
      successMsg,
    } = this.props;

    if (successDisplayed) {
      if (successType === 'individual') {
        this.setState({
          dialogDisplayed: steps.finish.name,
        });
      } else {
        window.location.href = successMsg;
      }
    } else {
      this.handleDoorClose();
    }
  };

  handleExistingEntrySubmit = () => {
    const {
      steps,
    } = this.state;
    const {
      existingEntryDisplayed,
      existingEntryType,
      existingEntryMsg,
    } = this.props;

    if (existingEntryDisplayed) {
      if (existingEntryType === 'individual') {
        this.setState({
          dialogDisplayed: steps.entryExists.name,
        });
      } else {
        window.location.href = existingEntryMsg;
      }
    } else {
      this.handleDoorClose();
    }
  };

  handleDoorClose = () => {
    const {
      doorCloseClickAction,
    } = this.props;

    this.setState(this.getInitialState());
    doorCloseClickAction();
  };

  renderExistingEntry = () => {
    const {
      existingEntryType,
      existingEntryMsg,
    } = this.props;

    const {
      dialogDisplayed,
      steps,
    } = this.state;

    if (dialogDisplayed === steps.entryExists.name && existingEntryType === 'redirect') {
      window.location.href = existingEntryMsg;
    }

    return (
      <Step active>
        <Finish
          content={existingEntryMsg}
          closeHandler={this.handleDoorClose}
        />
      </Step>
    );
  };

  render() {
    const {
      number,
      internalPreview,
      dialogShown,
      data: {
        calendardoor_editor_prize,
        calendardoor_editor_question,
        calendardoor_answer_type,
        answer_values,
        calendardoor_editor_hint,
        calendardoor_duration_start_date,
        calendardoor_duration_end_date,
        calendardoor_data_query_fields,
        calendardoor_data_query_button,
        calendardoor_show_correct_answer,
        calendardoor_show_wrong_answer,
      },
      hasQuiz,
      showAnswer,
      collectUserData,
      formSchema,
      submitHandler,
      successMsg,
      existingEntryMsg,
      wrongDoor,
      wrongDoorContent,
      dataQueryHeadline,
    } = this.props;
    const {
      dialogDisplayed,
      steps,
      userData,
      fieldValidations,
    } = this.state;

    if (calendardoor_data_query_button === 'off') {
      if ( showAnswer ) {
        steps.question.toStep = "answer";
        steps.answer.toStep = "finish";
      } else {
        steps.question.toStep = "finish";
      }
    };

    const now = Math.round(Date.now() / 1000);
    let dialogOpen = dialogShown;
    let doorNotReady = false;

    if (
      now < parseInt(calendardoor_duration_start_date, 10)
      || now > parseInt(calendardoor_duration_end_date, 10)
    ) {
      doorNotReady = true;
    }

    if ( ( !internalPreview && wrongDoor == 'on' && doorNotReady ) ) {
      return (
          <DoorDialog
              className="adventcalendar__door-dialog"
              id={`adventcalendar-dialog-${number}`}
              dialogShown={dialogOpen}
          >
            <div className="adventcalendar__door-dialog-content">
              <Step active={true}>
                <Finish
                    content={wrongDoorContent}
                    closeHandler={this.handleDoorClose}
                />
              </Step>
            </div>
          </DoorDialog>
      );
    }
    
    return (
      <DoorDialog
        className="adventcalendar__door-dialog"
        id={`adventcalendar-dialog-${number}`}
        dialogShown={dialogOpen}
      >
        <div className="adventcalendar__door-dialog-content">
          <Step active={dialogDisplayed === steps.prize.name}>
            <Prize
              content={calendardoor_editor_prize}
              nextStep={steps.prize.toStep}
              nextStepHandler={this.proceedToNextStep}
              closeHandler={this.handleDoorClose}
            />
          </Step>

          <Step active={dialogDisplayed === steps.question.name}>
            {hasQuiz && (
              <Question
                content={calendardoor_editor_question}
                answerType={calendardoor_answer_type}
                answerValues={answer_values}
                inputAnswer={userData.answer}
                hint={calendardoor_editor_hint}
                handleAnswerInput={this.collectAnswer}
                nextStep={steps.question.toStep}
                nextStepHandler={this.proceedToNextStep}
                closeHandler={this.handleDoorClose}
              />
            )}
            {!hasQuiz && (
              <QuestionContent
                content={calendardoor_editor_question}
                dataQuery={calendardoor_data_query_button}
                nextStep={steps.question.toStep}
                nextStepHandler={this.proceedToNextStep}
                closeHandler={this.handleDoorClose}
              />
            )}
          </Step>

          <Step active={dialogDisplayed === steps.answer.name}>
          { showAnswer && (
            <Answer
              contentCorrect={calendardoor_show_correct_answer}
              contentWrong={calendardoor_show_wrong_answer}
              givenAnswer={this.state.userData.givenAnswer}
              nextStep={steps.answer.toStep}
              nextStepHandler={this.proceedToNextStep}
              previousStepHandler={this.backToPreviousStep}
              closeHandler={this.handleDoorClose}
            />
          )}
          </Step>

          {collectUserData && (
            <Step active={dialogDisplayed === steps.userData.name}>
              <UserData
                handleUserInput={this.collectUserData}
                formSchema={formSchema}
                formData={userData}
                nextStep={steps.userData.toStep}
                nextStepHandler={this.proceedToNextStep}
                closeHandler={this.handleDoorClose}
                submitHandler={submitHandler}
                fieldValidations={fieldValidations}
                selectedDataQuery={calendardoor_data_query_fields}
                dataQueryHeadline={dataQueryHeadline}
              />
            </Step>
          )}

          <Step active={dialogDisplayed === steps.finish.name}>
            <Finish
              content={successMsg}
              closeHandler={this.handleDoorClose}
            />
          </Step>
          <Step active={dialogDisplayed === steps.entryExists.name}>
            <Finish
              content={existingEntryMsg}
              closeHandler={this.handleDoorClose}
            />
          </Step>
        </div>
      </DoorDialog>
    );
  }
}

DoorDialogContainer.propTypes = {
  number: PropTypes.number.isRequired,
  dialogShown: PropTypes.bool.isRequired,
  doorCloseClickAction: PropTypes.func.isRequired,
  data: PropTypes.shape().isRequired,
  hasQuiz: PropTypes.bool.isRequired,
  showAnswer: PropTypes.bool.isRequired,
  collectUserData: PropTypes.bool.isRequired,
  formSchema: PropTypes.objectOf(formSchemaPropType).isRequired,
  submitHandler: PropTypes.func,
  entryUrl: PropTypes.string.isRequired,
  successDisplayed: PropTypes.bool.isRequired,
  successType: PropTypes.string.isRequired,
  successMsg: PropTypes.string.isRequired,
  existingEntryDisplayed: PropTypes.bool.isRequired,
  existingEntryType: PropTypes.string.isRequired,
  existingEntryMsg: PropTypes.string.isRequired,
  emptyFieldMsg: PropTypes.string.isRequired,
  emailFieldMsg: PropTypes.string.isRequired,
  internalPreview: PropTypes.bool.isRequired,
  dataQueryHeadline: PropTypes.string.isRequired,
};

DoorDialogContainer.defaultProps = {
  submitHandler: null,
};
